import axios from 'axios';
import store from 'store';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiClient.interceptors.request.use((request) => {
  const accessToken = store.get('accessToken');
  if (accessToken) {
    request.headers.Authorization = `Bearer ${accessToken}`;
    request.headers['x-access-token'] = accessToken;
    request.headers['Accept'] = 'application/json, multipart/form-data, application/x-www-form-urlencoded';
  }
  return request;
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      // ✅ 새 토큰으로 재요청 처리
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    const { data, status } = response || {};

    if (status === 401 && data?.message?.message === 'TokenExpire') {
      const originalRequest = error.config;

      // 이미 재시도 중이면 큐에 넣고 기다리기
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              originalRequest.headers['x-access-token'] = token;
              resolve(apiClient(originalRequest)); // ✅ 재요청
            },
            reject: (err) => {
              reject(err);
            },
          });
        });
      }

      isRefreshing = true;

      const refreshToken = store.get('refreshToken');

      try {
        const result = await apiClient.post('/login/token', {
          refreshToken: refreshToken,
        });

        const newAccessToken = result.data.result;
        store.set('accessToken', newAccessToken);

        processQueue(null, newAccessToken); // 큐 요청들 재시도

        // 현재 요청 재시도
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers['x-access-token'] = newAccessToken;
        return apiClient(originalRequest);
      } catch (err) {
        processQueue(err, null);
        store.remove('accessToken');
        store.remove('refreshToken');
        store.remove('userData');
        window.location.href = '/';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    // RefreshToken 만료 처리
    if (status === 401 && data?.message?.message === 'RefreshTokenExpire') {
      store.remove('accessToken');
      store.remove('refreshToken');
      store.remove('userData');
      window.location.href = '/';
    }

    // 기타 오류 alert
    if (!data?.success && data?.message) {
      if (data.message.message) {
        alert(data.message.message);
      } else {
        if (store.get('lang') === 'kr') {
          alert(data.message.message_ko);
        } else {
          alert(data.message.message_en);
        }
      }
    }

    return Promise.reject(error);
  },
);

export default apiClient;
